import { render, staticRenderFns } from "./ServiceListItems.vue?vue&type=template&id=5ac209d8"
import script from "./ServiceListItems.vue?vue&type=script&lang=js"
export * from "./ServiceListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports